const {GET_SECURITY_CLIENT} = require('shared/constants/ActionTypes');

const initialState = {
  securityClientData: null,
};

const securityClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SECURITY_CLIENT:
      return {
        ...state,
        securityClientData: action.payload.data,
      };
    default:
      return state;
  }
};

export default securityClientReducer;
